/* tslint:disable */
/* eslint-disable */
/**
 * NORA Api
 *  ## Headers  ### X-App-Version  Remember to include the `X-App-Version` header in every request. This will verify that the app version works with this API version. The API will return a `X-Minimum-App-Version` header as well including the minimum app version that is supported by this API. The contents of the header are is a JSON encoded DTO, `VersionHeaderDTO`. 
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction, replaceWithSerializableTypeIfNeeded } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { ApiResult } from '../models';
// @ts-ignore
import type { CountDrawLayers200Response } from '../models';
// @ts-ignore
import type { CreateDrawLayer200Response } from '../models';
// @ts-ignore
import type { GetDrawLayersByOperationId200Response } from '../models';
// @ts-ignore
import type { SearchGroupsAdmin200Response } from '../models';
// @ts-ignore
import type { SortOrder } from '../models';
/**
 * DrawLayerAdminApi - axios parameter creator
 */
export const DrawLayerAdminApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Returns the number of draw layers (admin)
         * @summary Count all draw layers (admin)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        countDrawLayers: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/nora/draw-layer/admin/count`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication keycloak required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "keycloak", [], configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Return a specific draw layer as admin
         * @summary Get a draw layer as admin
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDrawLayerById: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getDrawLayerById', 'id', id)
            const localVarPath = `/api/nora/draw-layer/admin/{id}`
                .replace('{id}', encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication keycloak required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "keycloak", [], configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * List all the draw layers a specific user has access to
         * @summary List all draw layers a user has access to
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDrawLayersByUserId: async (userId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('getDrawLayersByUserId', 'userId', userId)
            const localVarPath = `/api/nora/draw-layer/admin/user/{userId}`
                .replace('{userId}', encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication keycloak required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "keycloak", [], configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Search all draw layers (admin)
         * @param {string} [query] 
         * @param {string} [filter] 
         * @param {number} [skip] 
         * @param {number} [limit] 
         * @param {SortOrder} [sortOrder] 
         * @param {string} [cursor] 
         * @param {string} [sortBy] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchDrawLayersAdmin: async (query?: string, filter?: string, skip?: number, limit?: number, sortOrder?: SortOrder, cursor?: string, sortBy?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/nora/draw-layer/admin/search`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication keycloak required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "keycloak", [], configuration)

            if (query !== undefined) {
                localVarQueryParameter['query'] = query;
            }

            if (filter !== undefined) {
                localVarQueryParameter['filter'] = filter;
            }

            if (skip !== undefined) {
                localVarQueryParameter['skip'] = skip;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (sortOrder !== undefined) {
                localVarQueryParameter['sortOrder'] = sortOrder;
            }

            if (cursor !== undefined) {
                localVarQueryParameter['cursor'] = cursor;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sortBy'] = sortBy;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DrawLayerAdminApi - functional programming interface
 */
export const DrawLayerAdminApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = DrawLayerAdminApiAxiosParamCreator(configuration)
    return {
        /**
         * Returns the number of draw layers (admin)
         * @summary Count all draw layers (admin)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async countDrawLayers(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CountDrawLayers200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.countDrawLayers(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DrawLayerAdminApi.countDrawLayers']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Return a specific draw layer as admin
         * @summary Get a draw layer as admin
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDrawLayerById(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CreateDrawLayer200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDrawLayerById(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DrawLayerAdminApi.getDrawLayerById']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * List all the draw layers a specific user has access to
         * @summary List all draw layers a user has access to
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDrawLayersByUserId(userId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetDrawLayersByOperationId200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDrawLayersByUserId(userId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DrawLayerAdminApi.getDrawLayersByUserId']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Search all draw layers (admin)
         * @param {string} [query] 
         * @param {string} [filter] 
         * @param {number} [skip] 
         * @param {number} [limit] 
         * @param {SortOrder} [sortOrder] 
         * @param {string} [cursor] 
         * @param {string} [sortBy] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async searchDrawLayersAdmin(query?: string, filter?: string, skip?: number, limit?: number, sortOrder?: SortOrder, cursor?: string, sortBy?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SearchGroupsAdmin200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.searchDrawLayersAdmin(query, filter, skip, limit, sortOrder, cursor, sortBy, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DrawLayerAdminApi.searchDrawLayersAdmin']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * DrawLayerAdminApi - factory interface
 */
export const DrawLayerAdminApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = DrawLayerAdminApiFp(configuration)
    return {
        /**
         * Returns the number of draw layers (admin)
         * @summary Count all draw layers (admin)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        countDrawLayers(options?: RawAxiosRequestConfig): AxiosPromise<CountDrawLayers200Response> {
            return localVarFp.countDrawLayers(options).then((request) => request(axios, basePath));
        },
        /**
         * Return a specific draw layer as admin
         * @summary Get a draw layer as admin
         * @param {DrawLayerAdminApiGetDrawLayerByIdRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDrawLayerById(requestParameters: DrawLayerAdminApiGetDrawLayerByIdRequest, options?: RawAxiosRequestConfig): AxiosPromise<CreateDrawLayer200Response> {
            return localVarFp.getDrawLayerById(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * List all the draw layers a specific user has access to
         * @summary List all draw layers a user has access to
         * @param {DrawLayerAdminApiGetDrawLayersByUserIdRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDrawLayersByUserId(requestParameters: DrawLayerAdminApiGetDrawLayersByUserIdRequest, options?: RawAxiosRequestConfig): AxiosPromise<GetDrawLayersByOperationId200Response> {
            return localVarFp.getDrawLayersByUserId(requestParameters.userId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Search all draw layers (admin)
         * @param {DrawLayerAdminApiSearchDrawLayersAdminRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchDrawLayersAdmin(requestParameters: DrawLayerAdminApiSearchDrawLayersAdminRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<SearchGroupsAdmin200Response> {
            return localVarFp.searchDrawLayersAdmin(requestParameters.query, requestParameters.filter, requestParameters.skip, requestParameters.limit, requestParameters.sortOrder, requestParameters.cursor, requestParameters.sortBy, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for getDrawLayerById operation in DrawLayerAdminApi.
 */
export interface DrawLayerAdminApiGetDrawLayerByIdRequest {
    readonly id: string
}

/**
 * Request parameters for getDrawLayersByUserId operation in DrawLayerAdminApi.
 */
export interface DrawLayerAdminApiGetDrawLayersByUserIdRequest {
    readonly userId: string
}

/**
 * Request parameters for searchDrawLayersAdmin operation in DrawLayerAdminApi.
 */
export interface DrawLayerAdminApiSearchDrawLayersAdminRequest {
    readonly query?: string

    readonly filter?: string

    readonly skip?: number

    readonly limit?: number

    readonly sortOrder?: SortOrder

    readonly cursor?: string

    readonly sortBy?: string
}

/**
 * DrawLayerAdminApi - object-oriented interface
 */
export class DrawLayerAdminApi extends BaseAPI {
    /**
     * Returns the number of draw layers (admin)
     * @summary Count all draw layers (admin)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public countDrawLayers(options?: RawAxiosRequestConfig) {
        return DrawLayerAdminApiFp(this.configuration).countDrawLayers(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Return a specific draw layer as admin
     * @summary Get a draw layer as admin
     * @param {DrawLayerAdminApiGetDrawLayerByIdRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getDrawLayerById(requestParameters: DrawLayerAdminApiGetDrawLayerByIdRequest, options?: RawAxiosRequestConfig) {
        return DrawLayerAdminApiFp(this.configuration).getDrawLayerById(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * List all the draw layers a specific user has access to
     * @summary List all draw layers a user has access to
     * @param {DrawLayerAdminApiGetDrawLayersByUserIdRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getDrawLayersByUserId(requestParameters: DrawLayerAdminApiGetDrawLayersByUserIdRequest, options?: RawAxiosRequestConfig) {
        return DrawLayerAdminApiFp(this.configuration).getDrawLayersByUserId(requestParameters.userId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Search all draw layers (admin)
     * @param {DrawLayerAdminApiSearchDrawLayersAdminRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public searchDrawLayersAdmin(requestParameters: DrawLayerAdminApiSearchDrawLayersAdminRequest = {}, options?: RawAxiosRequestConfig) {
        return DrawLayerAdminApiFp(this.configuration).searchDrawLayersAdmin(requestParameters.query, requestParameters.filter, requestParameters.skip, requestParameters.limit, requestParameters.sortOrder, requestParameters.cursor, requestParameters.sortBy, options).then((request) => request(this.axios, this.basePath));
    }
}

